import React from 'react'
import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { isHighSchoolDashboard, isHighSchoolUrl } from 'utils/highschoolHelpers'
import {
  isDigitalWellBeingUrl,
  isK5Dashboard,
  isK5Url,
  isMiddleSchoolDashboard,
  isMiddleSchoolUrl,
} from 'utils/productHelpers'

// Mirrors CurrentSiteTile color logic so the Print Page link matches the
// adjacent site selector's themed color.
export function getPrintLinkColor() {
  if (isHighSchoolDashboard() || isHighSchoolUrl()) {
    return themeGet('colors.hsPrimaryPink')
  }
  if (
    isMiddleSchoolDashboard() ||
    isMiddleSchoolUrl() ||
    isDigitalWellBeingUrl()
  ) {
    return themeGet('colors.blue')
  }
  if (isK5Dashboard() || isK5Url()) {
    return themeGet('colors.elemDigital1')
  }
  return themeGet('colors.icon.light')
}

export const PrintButton = styled.button.attrs({
  type: 'button',
})`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  background: none;
  border: none;
  padding: 0;
  margin: 0 1.5rem 0 0;
  font-family: ${themeGet('font.molde.medium')};
  font-size: 1rem;
  line-height: 1.063rem;
  letter-spacing: 0;
  white-space: nowrap;
  color: ${props => getPrintLinkColor()(props)};
  cursor: pointer;

  :hover {
    color: ${themeGet('colors.hsSecondaryGreen')};
  }

  :focus-visible {
    outline: 0.125rem solid
      ${themeGet('individualResource.teachButton.focusOutline')};
    outline-offset: 0.125rem;
    border-radius: 0.125rem;
  }

  svg {
    flex-shrink: 0;
  }
`

export const PrintIcon = props => (
  <svg
    aria-hidden="true"
    focusable="false"
    height="17px"
    role="presentation"
    viewBox="0 0 20 20"
    width="20px"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.6"
      transform="translate(1.5, 1.5)"
    >
      <path d="M3.5,5 L3.5,0.5 L13.5,0.5 L13.5,5" />
      <path d="M3.5,12.5 L1.5,12.5 C0.671572875,12.5 0,11.8284271 0,11 L0,6.5 C0,5.67157288 0.671572875,5 1.5,5 L15.5,5 C16.3284271,5 17,5.67157288 17,6.5 L17,11 C17,11.8284271 16.3284271,12.5 15.5,12.5 L13.5,12.5" />
      <path d="M3.5,10 L13.5,10 L13.5,16.5 L3.5,16.5 L3.5,10 Z" />
    </g>
  </svg>
)

export const PrintCopyright = styled.span`
  display: none;
  font-family: ${themeGet('font.molde.regular')};
  font-size: 0.625rem;
  line-height: 1.2;
  color: ${themeGet('colors.darkGray')};
  text-align: left;
  padding: 0.25rem 0.5rem;
`
